import i18n from 'ui/i18n';

import {ShareType} from './Share.types';

export const shareTitleByType: Record<ShareType, string> = {
    [ShareType.Form]: i18n('success-page', 'share-form'),
    [ShareType.Stats]: i18n('success-page', 'share-stats'),
    [ShareType.Results]: i18n('success-page', 'share-results'),
};
